/* ==========================================================================
   SearcherTrainHotel > Calendar
   ========================================================================== */

/* Modules */
const CalendarClient = require('@bluekiri/alexandria-contrib-components/components/calendar/client/js');
const calendarHelper = require('../../../../helpers/calendar');

function initCalendar(selector, instance, configuration) {
    const result = instance;
    const config = configuration;

    config.onChange = [
        function fn() {
            const selectedDay = this.fp.selectedDateElem;
            // disabled day, you can't select the same date departure than return
            selectedDay.classList.add('disabled');
            selectedDay.blur();
        }
    ];

    config.fp = {
        minDate: new Date().fp_incr(2),
        ariaDateFormat: 'Y/m/d',
        // eslint-disable-next-line max-params
        onDayCreate: (dObj, dStr, fp, dayElem) => {
            if (instance.config.disableDays) {
                if (instance.config.disableDays.find(item => item === dayElem.getAttribute('aria-label'))) {
                    dayElem.classList.add('flatpickr-disabled', 'disabled');
                }
            }
        }
    };

    const calendar = CalendarClient(selector, config);
    result.calendar = calendar;

    calendarHelper.setDefaultDates(instance, calendar);

    calendar.input.set(calendar.input.get());
    calendar.currentDates = calendar.get();
    calendar.fp.config.onClose = [
        () => {
            if (calendar.get().length === 0 || calendar.get().length === 1) {
                calendar.input.setActive();
                calendar.setDate(calendar.currentDates);
            }

            calendar.currentDates = calendar.get();
        }
    ];
}

module.exports = {
    initCalendar
};
